module.exports = __webpack_public_path__ + "static/img/yuer.a5121ef5.png";